import { monthsConstant } from "src/app/course-planning/constants/constants";

export const getMonthName = (monthNumber: number): string => {
  const m = monthsConstant.find(m => Number(m.number) === Number(monthNumber));
  if (!m) {
    throw new Error("Not Month Found");
  }
  return m.label;
};
